/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateEffectiveLaborCostRequest } from '../../models/create-effective-labor-cost-request';

export interface CreateEffectiveLaborCost$Params {
      body: CreateEffectiveLaborCostRequest
}

export function createEffectiveLaborCost(http: HttpClient, rootUrl: string, params: CreateEffectiveLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, createEffectiveLaborCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

createEffectiveLaborCost.PATH = '/v0/effectiveLaborCost';
